import { selectForm } from 'app/core/interfaces/authorization.types';
import { CalendarComponent } from 'app/modules/organization/pages/schedule/calendar/calendar.component';
import { ScheduleSelectComponent } from 'app/modules/practitioner/pages/schedule/select/schedule-select.component';
import { ScheduleComponent } from 'app/modules/secretaries/pages/schedule/schedule.component';
import { HomePatientComponent } from 'app/pages/home/patient/home-patient.component';

export const homeType: selectForm[] = [
  {
    id: 'organization',
    name: 'Instituição',
    component: CalendarComponent,
  },
  {
    id: 'secretary',
    name: 'Secretária(o)',
    component: ScheduleComponent,
  },
  {
    id: 'patient',
    name: 'Paciente',
    component: HomePatientComponent,
  },
  {
    id: 'practitioner',
    name: 'Especialista',
    component: ScheduleSelectComponent,
  },
];
